import { Injectable } from "@angular/core";
import { EntityStoreService } from "../../../../shared/store/entity-store/entity-store.service";
import {
  EntityMetadata,
  EntityStoreState,
} from "../../../../shared/store/store-types.model";
import { NonConformiteFacadeService } from "./non-conformite-facade.service";
import { NonConformite } from "../../models/non-conformite.model";

@Injectable({ providedIn: "root" })
export class NonConformiteStoreService extends EntityStoreService<
  NonConformite,
  EntityMetadata,
  NonConformiteState
> {
  constructor() {
    super({
      ...EntityStoreService.initialState,
      selectedNcId: null,
    });
  }
}

export interface NonConformiteState
  extends EntityStoreState<NonConformiteFacadeService> {
  selectedNcId: string | null;
}
